import { render, staticRenderFns } from "./EditDoctor.vue?vue&type=template&id=4313014a&scoped=true&"
import script from "./EditDoctor.vue?vue&type=script&lang=js&"
export * from "./EditDoctor.vue?vue&type=script&lang=js&"
import style0 from "./EditDoctor.vue?vue&type=style&index=0&id=4313014a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4313014a",
  null
  
)

export default component.exports